import Interceptor from "./Interceptor";

export const getSubscription = async () => {
  const response = await Interceptor.get("/billing/subscription");
  return response.data;
};

export const createCheckoutSession = async (planId, billingInterval) => {
  const response = await Interceptor.post("/billing/checkout-session", {
    planId,
    billingInterval,
  });
  return response.data;
};

export const createPortalSession = async () => {
  const response = await Interceptor.post("/billing/customer-portal");
  return response.data;
};

export const changePlan = async (planId, billingInterval) => {
  const response = await Interceptor.post("/billing/change-plan", {
    planId,
    billingInterval,
  });
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await Interceptor.post("/billing/cancel");
  return response.data;
};

export const resumeSubscription = async () => {
  const response = await Interceptor.post("/billing/resume");
  return response.data;
};

export const getInvoices = async (limit = 20) => {
  const response = await Interceptor.get(`/billing/invoices?limit=${limit}`);
  return response.data;
};
